var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C10.4087 0 8.88258 0.632141 7.75736 1.75736C6.63214 2.88258 6 4.4087 6 6C6 7.5913 6.63214 9.11742 7.75736 10.2426C8.88258 11.3679 10.4087 12 12 12C13.5913 12 15.1174 11.3679 16.2426 10.2426C17.3679 9.11742 18 7.5913 18 6C18 4.4087 17.3679 2.88258 16.2426 1.75736C15.1174 0.632141 13.5913 0 12 0ZM12 2.85C13.74 2.85 15.15 4.26 15.15 6C15.15 7.74 13.74 9.15 12 9.15C11.1646 9.15 10.3634 8.81813 9.77261 8.22739C9.18187 7.63665 8.85 6.83543 8.85 6C8.85 5.16457 9.18187 4.36335 9.77261 3.77261C10.3634 3.18187 11.1646 2.85 12 2.85ZM12 13.5C7.995 13.5 0 15.495 0 19.5V24H24V19.5C24 15.495 16.005 13.5 12 13.5ZM12 16.35C16.455 16.35 21.15 18.54 21.15 19.5V21.15H2.85V19.5C2.85 18.54 7.5 16.35 12 16.35Z",
    fill: "#AAAFBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.37a5d775d5a8795f29c78c62110d2e7b.svg";
export { ForwardRef as ReactComponent };